// extracted by mini-css-extract-plugin
export default {"input":"style_input__8ClBt","valueAndClear":"style_valueAndClear__ta1iC"};